/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { Observer } from 'mobx-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  IconButton,
  TextField,
  Snackbar,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import EmailIcon from '@material-ui/icons/Email';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackBars } from '../../../alerts/SnackBarProvider';
import { COLORS } from '../../util/Colors';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv } from '../../styles/styles';

const ReferralLink = () => {
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [accountInfo, setAccountInfo] = useState(null);
  const [refCode, setRefCode] = useState('');
  const { authStore, orgStore } = useRootStore();
  const [email, setEmail] = useState('');
  const REF_STRING = `${process.env.REACT_APP_DOMAIN}/login?ref_code=${refCode}`;
  const handleAlert = useSnackBars();

  const handleClick = () => setOpen(true);
  const handleClose = (e, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    const getAccountInfo = async () => {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/user`,
      );
      setAccountInfo(data);
    };

    const getRefCode = async () => {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/referral-code`,
      );
      setRefCode(Object.values(data)[0]);
    };
    const initialActions = async () => {
      await Promise.all([getAccountInfo(), getRefCode()]);
    };
    initialActions();
  }, []);

  const sendEmail = async () => {
    try {
      const res = await authStore.request.post(
        `${process.env.REACT_APP_API}/api/send-referral-link`,
        {
          email,
          name: accountInfo.Name,
          refLink: REF_STRING,
        },
      );
      res.status === 200 &&
        handleAlert('Email Sent Successfully', COLORS.green);

      return res;
    } catch (e) {
      handleAlert('Something went wrong', COLORS.red);
    }
  };

  const handleSubmit = async () => {
    await sendEmail();
    handleCloseDialog();
  };

  return (
    <Observer
      render={() => {
        return (
          <FlexDiv>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '75%',
                height: 'inherit',
                marginTop: '20px',
              }}
            >
              <TextField
                name="referral"
                fullWidth
                label="Referral Link"
                value={REF_STRING}
                margin="normal"
                variant="outlined"
              />
              <div className="buttons" style={{ display: 'flex' }}>
                <Button
                  color="primary"
                  variant="contained"
                  startIcon={<EmailIcon />}
                  style={{ marginRight: '8px' }}
                  onClick={handleClickOpen}
                  size="small"
                >
                  Send
                </Button>
                <CopyToClipboard text={REF_STRING} onCopy={handleClick}>
                  <Button
                    aria-label="Copy"
                    color="primary"
                    variant="contained"
                    size="small"
                    startIcon={<AttachFileIcon />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </div>
            {/* <Box my={1}>
              <Typography
                variant="h4"
                gutterBottom
                component="a"
                color="textSecondary"
                target="_top"
                href={MAILTO}
                style={{ textDecoration: 'none' }}
              >
                Send referral link
              </Typography>
            </Box> */}

            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              open={open}
              autoHideDuration={3000}
              onClose={handleClose}
              ContentProps={{
                'aria-describedby': 'message-id',
              }}
              message={<span id="message-id">Copied to clipboard</span>}
              action={
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>
              }
            />
            <Dialog
              open={openDialog}
              onClose={handleCloseDialog}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Referral Link</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  We will send a referral link on your behalf, enter the
                  recipient's email below to proceed.
                </DialogContentText>
                <TextField
                  autoFocus
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  margin="dense"
                  id="email"
                  label="Email Address"
                  type="email"
                  fullWidth
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDialog} color="primary">
                  Cancel
                </Button>
                <Button onClick={() => handleSubmit()} color="primary">
                  Send
                </Button>
              </DialogActions>
            </Dialog>
          </FlexDiv>
        );
      }}
    />
  );
};

export default ReferralLink;
